// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__HNaLV","header":"ReportDetails_header__3JxvK","title":"ReportDetails_title__2Q5SP","left":"ReportDetails_left__3Yf9w"};